import { IItemKey } from 'api/catalog/models';

export const DEFAULT_DETAILS_FIELD_VISIBILITY: IItemKey[] = [
  'brandName',
  'departmentName',
  'categoryName',
  'subcategoryName',
  'organicCode',
  'packSize',
  'countryOfOriginName',
  'upc',
  'plu',
  'isPrivateLabel',
  'statusCode',
  'itemNumber',
  'description',
];

export const DISABLED_DETAILS_FIELD_VISIBILITY: IItemKey[] = [
  'itemAtOtherDcs',
  'additionalDetails',
  'assets',
  'ingredients',
  'itemAttributes',
];
